import { createIsTuwyCustomerEndpoint } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useQuery } from 'react-query';

function useIsTuwyCustomerQuery(customerId?: string | null) {
  return useQuery({
    queryFn: async () => {
      return customerId
        ? await apiService.get<{ isTuwyCustomer: boolean }>({
            url: createIsTuwyCustomerEndpoint(customerId),
          })
        : Promise.reject();
    },
    queryKey: `gemini-journey-api-is-tuwy-customer-${customerId}`,
  });
}

export { useIsTuwyCustomerQuery };
